export type CoverageStaff = {
  id: string;
  name: string;
  email?: string | null;
};

export type CoverageSectionOffice = {
  mainAddress?: {
    city?: string | null;
    state?: string | null;
  } | null;
};

export type CoverageSection = {
  id: string;
  name: string;
  recruiter?: CoverageStaff | null;
  playerEngagementConsultant?: CoverageStaff | null;
  sectionOffice?: CoverageSectionOffice | null;
};

export type CoverageRoleKind = "recruiter" | "playerEngagement";

export const COVERAGE_GROUP_BY_PARAM = "groupBy";
export const UNASSIGNED_COVERAGE_GROUP_ID = "unassigned";

export type CoverageGroupBy = "consultant" | "section";

export type CoverageGroupMember = {
  id: string;
  sectionId: string;
  sectionName: string;
  person: CoverageStaff | null;
  assignmentId?: string;
  location?: string | null;
};

export type CoverageGroupRow = {
  id: string;
  label: string;
  location?: string | null;
  isUnassigned: boolean;
  canAdd: boolean;
  members: CoverageGroupMember[];
  lockedSectionId?: string;
  lockedSectionName?: string;
  lockedPerson?: CoverageStaff | null;
};

export type SectionOption = {
  id: string;
  name: string;
};

export type CareerConsultantAssignment = {
  id: string;
  isActive: boolean;
  section: {
    id: string;
    name: string;
  };
  consultant: CoverageStaff;
};
